import type { FeatureManifest } from '../registry.js';

/**
 * SO-01 restock: ask a friend (link + share sheet), buy for gems, or a rewarded fast restock.
 * A friend's restock link opened in the app (/s/:id, resolved by features/links) plays the
 * help order here (SO-01.2).
 */
export default {
  id: 'restock',
  art: ['rare'],
  provides: ['restock'],
  links: ['restock'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
